import React, {Component} from 'react';
import { Form, Checkbox } from 'semantic-ui-react'
import PropTypes from 'prop-types';

class RubricaTipoSoggettoSelect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fields: {
                isCliente: props.isCliente,
                isFornitore: props.isFornitore,
                isTp: props.isTp,
                isProspect: props.isProspect,
            }
        };
        this.onTipoChange = this.onTipoChange.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            fields: {
                isCliente: nextProps.isCliente,
                isFornitore: nextProps.isFornitore,
                isTp: nextProps.isTp,
                isProspect: nextProps.isProspect,
            }
        })
    }

    onTipoChange(a1, {name, checked}){
        let fields = this.state.fields;
        fields[name] = checked;
        this.setState({fields})
        this.props.onChange(fields.isProspect, fields.isCliente, fields.isFornitore, fields.isTp);
    }

    render() {
        return (
        <div className="ui stackable form">
            <Form.Group widths="2">
                <Form.Field inline >
                    <Checkbox label="Prospect" name="isProspect" toggle checked={this.state.fields.isProspect} onChange={this.onTipoChange} />
                </Form.Field>
                <Form.Field inline >
                    <Checkbox label="Clienti" name="isCliente" toggle checked={this.state.fields.isCliente} onChange={this.onTipoChange} />
                </Form.Field>
            </Form.Group>
            <Form.Group widths="2">
                <Form.Field inline >
                    <Checkbox label="Fornitori" name="isFornitore" toggle checked={this.state.fields.isFornitore} onChange={this.onTipoChange} />
                </Form.Field>
                <Form.Field inline >
                    <Checkbox label="Terze parti" name="isTp" toggle checked={this.state.fields.isTp} onChange={this.onTipoChange} />
                </Form.Field>
            </Form.Group>
        </div>)
    }
}

RubricaTipoSoggettoSelect.PropTypes = {
    isProspect: PropTypes.bool.isRequired,
    isCliente: PropTypes.bool.isRequired,
    isFornitore: PropTypes.bool.isRequired,
    isTp: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
};

RubricaTipoSoggettoSelect.defaultProps = {
    isProspect: false,
    isCliente: false,
    isFornitore: false,
    isTp: false,
};
export default RubricaTipoSoggettoSelect;




/** WEBPACK FOOTER **
 ** ./src/components/rubrica/RubricaTipoSoggettoSelect.js
 **/